(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moments-with-manjari"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".editorial-image-grid").forEach(function(section) {

    const slider = section.querySelector(".editorial-image-slider");
    const track = section.querySelector(".editorial-image-track");

    if (!track) return;

    const originalCount = track.children.length;
    if (originalCount < 2) return;

    track.innerHTML += track.innerHTML;

    let position = 0;
    const speed = 0.35;
    let isPaused = false;
    let isDragging = false;
    let startX = 0;
    let previousPosition = 0;

    function animate() {
      if (!isPaused && !isDragging) {
        position += speed;
        if (position >= track.scrollWidth / 2) {
          position = 0;
        }
        track.style.transform = `translate3d(-${position}px,0,0)`;
      }
      requestAnimationFrame(animate);
    }

    animate();

    section.querySelectorAll(".editorial-image-item").forEach(item => {
      item.addEventListener("mouseenter", () => isPaused = true);
      item.addEventListener("mouseleave", () => isPaused = false);
    });

    slider.addEventListener("mousedown", e => {
      isDragging = true;
      startX = e.pageX;
      previousPosition = position;
    });

    window.addEventListener("mouseup", () => { isDragging = false; });

    window.addEventListener("mousemove", e => {
      if (!isDragging) return;
      const walk = e.pageX - startX;
      position = previousPosition - walk;
      if (position < 0) position = track.scrollWidth / 2;
      if (position >= track.scrollWidth / 2) position = 0;
      track.style.transform = `translate3d(-${position}px,0,0)`;
    });

    slider.addEventListener("touchstart", e => {
      isDragging = true;
      startX = e.touches[0].clientX;
      previousPosition = position;
    });

    slider.addEventListener("touchend", () => { isDragging = false; });

    slider.addEventListener("touchmove", e => {
      if (!isDragging) return;
      const walk = e.touches[0].clientX - startX;
      position = previousPosition - walk;
      if (position < 0) position = track.scrollWidth / 2;
      if (position >= track.scrollWidth / 2) position = 0;
      track.style.transform = `translate3d(-${position}px,0,0)`;
    });

  });

});

  } catch(e) { console.error(e); }
})();
})();
